
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import ReactGA from "react-ga4";

ReactGA.initialize("G-5EFYYSY1BT");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/cngupta/"> {/** REMOVE THE 'basename="/cngupta/"' WHILE RUNNING APP IN LOCAL */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
